import "./AboutUs.module.css";
import Header from "@/reusable_sections/Header";
import Title from "./sections/Title";
import MeetTheTeam from "./sections/MeetTheTeam";
import Footer from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <Header />
      <Title />
      <MeetTheTeam />
      <Footer />
    </div>;
}